import React, { useRef, useState, useEffect, useContext } from 'react';
import { Container, Form, Button, Row, Col, Table, Alert, Card, Badge, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import api from '../../services/api';
import './Order.css';
import { FaSearch } from 'react-icons/fa';
import { useTranslation } from 'react-i18next'

const OrderNew = () => {
  let { user, selectedCustomer } = useContext(AuthContext);
  const navigate = useNavigate();
  // const displayAtt = user.role !== 0 ? 'none' : '';
  const wwidth = window.innerWidth;
  const initialOrderItems = {};
  const [isEnlarged, setIsEnlarged] = useState(false);

  const { t, i18n } = useTranslation();
  let orderExists = false;
  useEffect(() => {
    if (localStorage.getItem('slang')) {
      i18n.changeLanguage(localStorage.getItem('slang'));
    } else {
      i18n.changeLanguage('zh');
      localStorage.setItem('slang', 'zh');
    }
  }, [i18n]);

  // 表單數據
  const [formData, setFormData] = useState({
    customerCode: '',
    deliveryDate: '',
    div: '10', // 預設為牛奶
  });

  // 訂單項目
  const [orderItems, setOrderItems] = useState([]);
  let totalOrderQuantity = useState(0);
  const [newFavorite, setNewFavorite] = useState([]);
  const [oldFavorite, setOldFavorite] = useState([]);

  // 已選擇的產品列表
  const [selectedNS, setSelectedNS] = useState([]);
  const [selectedRP, setSelectedRP] = useState([]);
  const [selectedSA, setSelectedSA] = useState([]);
  const [selectedAll, setSelectedAll] = useState([]);

  // 設定列表
  const [sharedconfigs, setSharedConfigs] = useState([]);

  // 可用客戶列表
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [searchCustomer, setSearchCustomer] = useState('');

  // 可用產品列表
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchProducts, setSearchProducts] = useState('');

  // 頁面狀態
  const [loading, setLoading] = useState(false);
  const [favoritesLoading, setFavoriteLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [agree, setAgree] = useState(0);
  const [needVanSale, setNeedVanSale] = useState(0);
  const [skip, setSkip] = useState(0);
  let custCode = useRef(null);
  let ns_max = useRef(999);
  let rp_max = useRef(99);
  let sa_max = useRef(999);
  let bdo_ddate_length = useRef(2), cus_ddate_length = useRef(1), saturday_ddate_length = useRef(1);
  let loop_ddate_length = useRef(14);
  let cutoff = useRef('14:00:00');
  let use_backend = useRef('Y');
  let cutoff_str = useRef('CUTOFF_1');
  let skip_date = useRef([]);

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const year = tomorrow.getFullYear();
  const month = String(tomorrow.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(tomorrow.getDate()).padStart(2, '0');
  const tomorrowDate = `${year}-${month}-${day}`;

  // 載入客戶列表
  useEffect(() => {
    loadCustomers();
  }, [user]);

  const loadCustomers = async () => {
    try {
      await loadConfigs();
      if (user.role === 0) {
        // 管理員 - 載入所有客戶
        // const response = await api.get('/customers');
        const response = await api.get('/customers/relations/user/' + user.login_id);
        setCustomers(await response.data.data);
        setFilteredCustomers(await response.data.data);
      } else {
        // 一般用戶 - 載入關聯客戶
        const response = await api.get('/auth/customers');
        setCustomers(await response.data.data);
        setFilteredCustomers(await response.data.data);

        if (!selectedCustomer) {
          selectedCustomer = response.data.data[0];
        }
        // 如果已有選擇的客戶，使用該客戶
        if (selectedCustomer) {
          if (selectedCustomer.sales_office === 'MT') {
            cutoff_str.current = 'CUTOFF_1';
          }
          if (selectedCustomer.sales_office === 'GT') {
            cutoff_str.current = 'CUTOFF_2';
          }
          setFormData({
            ...formData,
            customerCode: selectedCustomer.cust_code
          });
          custCode.current = selectedCustomer.cust_code;
          // 當選擇了客戶，載入對應的產品
          await loadProducts(selectedCustomer.cust_code, formData.div);
          // await loadDeliveryDate();
        }
      }
    } catch (err) {
      console.error('載入客戶失敗:', err);
      setError(t('loadCustErr') + ': ' + (err.response?.data?.message || t('msg_tryLater')));
      window.scrollTo(0, 0);
    }
  };


  // 當客戶或部門變更時，載入產品列表
  useEffect(() => {
    if (formData.customerCode) {
      loadConfigs();
      loadProducts(formData.customerCode, formData.div);
      if (user.role !== 0) {
        loadDeliveryDate();
      }
      setSelectedNS([]);
      setSelectedRP([]);
      setSelectedSA([]);
      setSelectedAll([]);
      setOldFavorite([]);
      setNewFavorite([]);
      // document.getElementById("skip").disabled = false;
      // checkOrderExist(formData.customerCode, formData.deliveryDate);
    }
  }, [formData.customerCode, formData.div]);

  // 當搜尋詞變化時，過濾產品列表
  useEffect(() => {
    if (!searchProducts.trim()) {
      setFilteredProducts(products);
    } else {
      const filtered = products.filter(product =>
        product.item_desc.toLowerCase().includes(searchProducts.toLowerCase()) || product.item_code.toLowerCase().includes(searchProducts.toLowerCase())
      );
      setFilteredProducts(filtered);
    }
  }, [searchProducts, products]);

  useEffect(() => {
    if (!searchCustomer.trim()) {
      setFilteredCustomers(customers);
    } else {
      const filtered = customers.filter(customer =>
        customer.cust_name.toLowerCase().includes(searchCustomer.toLowerCase()) || customer.cust_code.toLowerCase().includes(searchCustomer.toLowerCase())
      );
      setFilteredCustomers(filtered);
    }
  }, [searchCustomer, customers]);

  const loadConfigs = async () => {
    try {
      const configResponse = await api.get(`/sharedconfigs/`);
      setSharedConfigs(await configResponse.data.data);
      sharedconfigs.forEach(configs => {
        if (configs.zkey === cutoff_str.current) {
          cutoff.current = configs.zvalue;
        }
      });
    } catch (err) {
      setError(t('msg_loadconfigFail') + ': ' + (err.response?.data?.message || t('msg_tryLater')));
      setSharedConfigs([]);
      window.scrollTo(0, 0);
    }
  };

  // 載入產品列表
  const loadProducts = async (customerCode, div) => {
    setProductLoading(true);
    setError('');
    setSearchProducts('');

    try {
      // console.log('載入產品，參數:', { customerCode, div });
      const response = await api.get('/products', {
        params: { customerCode, div }
      });

      // console.log('產品API響應:', response.data);
      const productsData = await response.data.data || [];
      setProducts(productsData);
      setFilteredProducts(productsData);

      productsData.forEach(product => {
        if (product.seq !== null) {
          setOldFavorite((prevFavorites) => [
            ...(prevFavorites || []),
            { customer: formData.customerCode, item: product.item_code, seq: product.seq }
          ]);
          setNewFavorite((prevFavorites) => [
            ...(prevFavorites || []),
            { customer: formData.customerCode, item: product.item_code, seq: product.seq }
          ]);
        }
        initialOrderItems[product.item_code] = {
          image_url: '',
          item_desc: '',
          orderQty: 0,
          replaceQty: 0,
          sampleQty: 0
        };
      });
      setOrderItems(initialOrderItems);

    } catch (err) {
      setError(t('msg_loadItemFail') + ': ' + (err.response?.data?.message || t('msg_tryLater')));
      setProducts([]);
      setFilteredProducts([]);
      window.scrollTo(0, 0);
    } finally {
      setProductLoading(false);
      setFavoriteLoading(false);
    }
  };

  i18n.on('languageChanged', () => {
    if (document.getElementById('deliveryDate') != null) {
      //  loadDeliveryDate();
    }
  });

  // 載入配送日期
  const loadDeliveryDate = async () => {
    let select = document.getElementById('deliveryDate');
    if (select != null) {
      select.innerHTML = '';
    }
    try {
      sharedconfigs.forEach(configs => {
        if (configs.zkey === 'USE_BACKEND') {
          use_backend.current = configs.zvalue;
        }
      });
      const response = await api.get(`/customers/schedule/${custCode.current}/${formData.div}`);
      if (!await response.data.data.length > 0) {
        const schedule = await response.data.data.schedules[0];
        if (use_backend.current === 'Y') {
          if (select != null && document.getElementById("deliveryDate").options.length === 0) {
            sharedconfigs.forEach(configs => {
              if (configs.zkey === 'BDO_DCOUNT') {
                bdo_ddate_length.current = configs.zvalue;
              }
              if (configs.zkey === 'CUS_DCOUNT') {
                cus_ddate_length.current = configs.zvalue;
              }
              if (configs.zkey === 'SAT_DCOUNT') {
                saturday_ddate_length.current = configs.zvalue;
              }
              if (configs.zkey === 'LOOP_DATE') {
                loop_ddate_length.current = configs.zvalue;
              }
              if (configs.zkey === 'SKIP_DATE') {
                skip_date.current = configs.zvalue;
              }
            });
            for (let i = 0; i <= schedule.dateList.length; i++) {
              let opt = document.createElement('option');
              opt.value = schedule.dateList[i].slice(0, 10);
              const day = new Date(schedule.dateList[i].slice(0, 10)).getDay();
              let dayDisplay = '';
              switch (day) {
                case 1:
                  dayDisplay = i18n.t('monday');
                  break;
                case 2:
                  dayDisplay = i18n.t('tuesday');
                  break;
                case 3:
                  dayDisplay = i18n.t('wednesday');
                  break;
                case 4:
                  dayDisplay = i18n.t('thursday');
                  break;
                case 5:
                  dayDisplay = i18n.t('friday');
                  break;
                case 6:
                  dayDisplay = i18n.t('saturday');
                  break;
                case 0:
                  dayDisplay = i18n.t('sunday');
                  break;
                default:
                  dayDisplay = '--';
              }
              opt.innerHTML = schedule.dateList[i].slice(0, 10) + "(" + dayDisplay + ")";
              select.appendChild(opt);
              if (user.role === 0) {
                if (schedule.today_day === 'Saturday') { // if today is saturday, show next 3 delivery options
                  if (document.getElementById("deliveryDate").options.length === (parseInt(saturday_ddate_length.current) + parseInt(bdo_ddate_length.current))) {
                    break;
                  }
                } else { // if others, show next 2 delivery options
                  if (document.getElementById("deliveryDate").options.length === parseInt(bdo_ddate_length.current)) {
                    break;
                  }
                }
              } else {
                if (schedule.today_day === 'Saturday' && schedule.cutoff > schedule.hkTime) { // if today is saturday(before cutoff), show next 2 delivery options
                  if (document.getElementById("deliveryDate").options.length === (parseInt(saturday_ddate_length.current) + parseInt(cus_ddate_length.current))) {
                    break;
                  }
                } else { // if others, show next delivery option
                  if (document.getElementById("deliveryDate").options.length === parseInt(cus_ddate_length.current)) {
                    break;
                  }
                }
              }
            }
          }
        } else {
          let rt_mon = schedule.rt_mon, rt_tue = schedule.rt_tue, rt_wed = schedule.rt_wed, rt_thu = schedule.rt_thu,
            rt_fri = schedule.rt_fri, rt_sat = schedule.rt_sat, rt_sun = schedule.rt_sun;

          const today = new Date();
          const rdate = new Date(today);
          let hktTime = new Date().toLocaleString('en-HK', { timeZone: 'Asia/Hong_Kong', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });

          sharedconfigs.forEach(configs => {
            if (configs.zkey === cutoff_str.current) {
              cutoff.current = configs.zvalue;
              hktTime = new Date(configs.dt).toLocaleString('en-HK', { timeZone: 'Asia/Hong_Kong', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
            }
            if (configs.zkey === 'BDO_DCOUNT') {
              bdo_ddate_length.current = configs.zvalue;
            }
            if (configs.zkey === 'CUS_DCOUNT') {
              cus_ddate_length.current = configs.zvalue;
            }
            if (configs.zkey === 'SAT_DCOUNT') {
              saturday_ddate_length.current = configs.zvalue;
            }
            if (configs.zkey === 'LOOP_DATE') {
              loop_ddate_length.current = configs.zvalue;
            }
            if (configs.zkey === 'SKIP_DATE') {
              skip_date.current = configs.zvalue;
            }
          });
          cutoff.current.replaceAll(':', '');
          hktTime.replaceAll(':', '');
          if (cutoff.current > hktTime) {
            rdate.setDate(rdate.getDate() + 1); // start from tomorrow
          } else {
            rdate.setDate(rdate.getDate() + 2); // start the day after tomorrow
          }
          if (select != null && document.getElementById("deliveryDate").options.length === 0) {
            for (let i = 1; i <= loop_ddate_length.current; i++) {
              if (skip_date.current.includes(rdate.toJSON().slice(0, 10))) {
                rdate.setDate(rdate.getDate() + 1);
                continue;
              }
              const day = rdate.getDay();
              let dayDisplay = '';
              if (
                (day === 1 && rt_mon === 1) ||
                (day === 2 && rt_tue === 1) ||
                (day === 3 && rt_wed === 1) ||
                (day === 4 && rt_thu === 1) ||
                (day === 5 && rt_fri === 1) ||
                (day === 6 && rt_sat === 1) ||
                (day === 0 && rt_sun === 1)
              ) {
                let opt = document.createElement('option');
                opt.value = rdate.toJSON().slice(0, 10)
                switch (day) {
                  case 1:
                    dayDisplay = i18n.t('monday');
                    break;
                  case 2:
                    dayDisplay = i18n.t('tuesday');
                    break;
                  case 3:
                    dayDisplay = i18n.t('wednesday');
                    break;
                  case 4:
                    dayDisplay = i18n.t('thursday');
                    break;
                  case 5:
                    dayDisplay = i18n.t('friday');
                    break;
                  case 6:
                    dayDisplay = i18n.t('saturday');
                    break;
                  case 0:
                    dayDisplay = i18n.t('sunday');
                    break;
                  default:
                    dayDisplay = '--';
                }
                opt.innerHTML = rdate.toJSON().slice(0, 10) + "(" + dayDisplay + ")";
                select.appendChild(opt);
                if (user.role === 0) {
                  if (today.getDay() === 6) { // if today is saturday, show next 3 delivery options
                    if (document.getElementById("deliveryDate").options.length === (parseInt(saturday_ddate_length.current) + parseInt(bdo_ddate_length.current))) {
                      break;
                    }
                  } else { // if others, show next 2 delivery options
                    if (document.getElementById("deliveryDate").options.length === parseInt(bdo_ddate_length.current)) {
                      break;
                    }
                  }
                } else {
                  if (today.getDay() === 6 && cutoff.current > hktTime) { // if today is saturday(before cutoff), show next 2 delivery options
                    if (document.getElementById("deliveryDate").options.length === (parseInt(saturday_ddate_length.current) + parseInt(cus_ddate_length.current))) {
                      break;
                    }
                  } else { // if others, show next delivery option
                    if (document.getElementById("deliveryDate").options.length === parseInt(cus_ddate_length.current)) {
                      break;
                    }
                  }
                }
              }
              rdate.setDate(rdate.getDate() + 1);
            }
            formData.deliveryDate = document.getElementById("deliveryDate").options[0].value;
          }
        }
      }
    } catch (error) {
      console.error('加載客戶送貨日期失敗', error);
      setError(t('loadDateErr'));
      window.scrollTo(0, 0);
    }
  }

  const checkOrderExist = async (customerCode, deliveryDate) => {
    try {
      if (!customerCode) {
        return;
      }
      if (!deliveryDate) {
        deliveryDate = document.getElementById("deliveryDate").options[0].value;
      }
      let url = '/orders';
      const params = new URLSearchParams();
      params.append('startDate', deliveryDate);
      params.append('endDate', deliveryDate);
      params.append('customerCode', customerCode);
      params.append('action', 'createOrder');
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await api.get(url);

      // console.log('產品API響應:', response.data);
      const checkResult = await response.data.count;
      if (checkResult <= 0) {
        orderExists = false;
        setError('');
      } else {
        orderExists = true;
        setError(t('msg_orderExist'));
        window.scrollTo(0, 0);
        document.getElementById("myError").style.display = "block"
      }
    } catch (err) {
      orderExists = true; //20260707 if catch error assume order exists, not allow create order
      setError(t('msg_checkOrderExistFail') + ': ' + (err.response?.data?.message || t('msg_tryLater')));
      window.scrollTo(0, 0);
    }
  };

  // 處理表單變更
  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (e.target.name === 'customerCode' || e.target.name === 'div') {
      setNewFavorite([]);
      setOldFavorite([]);
      custCode.current = value;
      if (value) {
        customers.forEach(cust => {
          if (cust.cust_code === value) {
            selectedCustomer = cust;
          }
        });
        if (selectedCustomer.sales_office === 'MT') {
          cutoff_str.current = 'CUTOFF_1';
        }
        if (selectedCustomer.sales_office === 'GT') {
          cutoff_str.current = 'CUTOFF_2';
        }
        await loadDeliveryDate();
      }
      // await checkOrderExist(value, formData.deliveryDate);
    }
    setFormData({ ...formData, [name]: value });
    if (e.target.name === 'deliveryDate') {
      setError('');
      //   await checkOrderExist(formData.customerCode, value);
    }
  };

  // 處理搜尋變更
  const handleProductSearchChange = (e) => {
    setSearchProducts(e.target.value);
  };

  const handleCustomerSearchChange = (e) => {
    setSearchCustomer(e.target.value);
  };

  const handleFavorites = (productCode, action, seq) => {
    if (action === true) {
      setNewFavorite([...(newFavorite || []), { customer: formData.customerCode, item: productCode, seq: seq }]);
    } else {
      setNewFavorite(newFavorite.filter(p => !(p.item === productCode && p.seq === seq)));
    }
  }

  // 添加產品到訂單
  const handleAddProduct = (product, tranCode) => {
    sharedconfigs.forEach(configs => {
      if (configs.zkey === 'ZNS_MAX') {
        ns_max.current = configs.zvalue;
      }
      if (configs.zkey === 'ZRP_MAX') {
        rp_max.current = configs.zvalue;
      }
      if (configs.zkey === 'ZSA_MAX') {
        sa_max.current = configs.zvalue;
      }
    });
    const inputID = product.item_code + "_" + tranCode;
    if (tranCode === 'ZNS') {
      if (selectedNS.find(p => p.item_code === product.item_code)) {
        // 產品已在列表中，更新NS數量
        if (selectedNS.find(p => p.item_code === product.item_code).qty + 1 <= parseInt(ns_max.current)) {
          document.getElementById(inputID).value = parseInt(selectedNS.find(p => p.item_code === product.item_code).qty) + 1;
          setSelectedNS(selectedNS.map(p => p.item_code === product.item_code ? { ...p, qty: (p.qty || 0) + 1 } : p));
        }
      } else {
        // 添加NS新產品
        setSelectedNS([...selectedNS, { ...product, qty: 1 }]);
        document.getElementById(inputID).value = 1;
      }
    } else if (tranCode === 'ZRP') {
      if (selectedRP.find(p => p.item_code === product.item_code)) {
        // 產品已在列表中，更新RP數量
        if (selectedRP.find(p => p.item_code === product.item_code).qty + 1 <= parseInt(rp_max.current)) {
          document.getElementById(inputID).value = parseInt(selectedRP.find(p => p.item_code === product.item_code).qty) + 1;
          setSelectedRP(selectedRP.map(p => p.item_code === product.item_code ? { ...p, qty: (p.qty || 0) + 1 } : p));
        }
      } else {
        // 添加RP新產品
        setSelectedRP([...selectedRP, { ...product, qty: 1 }]);
        document.getElementById(inputID).value = 1;
      }
    } else if (tranCode === 'ZSA') {
      if (selectedSA.find(p => p.item_code === product.item_code)) {
        // 產品已在列表中，更新SA數量
        if (selectedSA.find(p => p.item_code === product.item_code).qty + 1 <= parseInt(sa_max.current)) {
          document.getElementById(inputID).value = parseInt(selectedSA.find(p => p.item_code === product.item_code).qty) + 1;
          setSelectedSA(selectedSA.map(p => p.item_code === product.item_code ? { ...p, qty: (p.qty || 0) + 1 } : p));
        }
      } else {
        // 添加SA新產品
        setSelectedSA([...selectedSA, { ...product, qty: 1 }]);
        document.getElementById(inputID).value = 1;
      }
    }
  };

  const handleSubtractProduct = (product, tranCode) => {
    const inputID = product.item_code + "_" + tranCode;
    // const result = [];
    if (tranCode === 'ZNS') {
      if (selectedNS.find(p => p.item_code === product.item_code)) {
        // 產品已在NS列表中，更新數量
        if (selectedNS.find(p => p.item_code === product.item_code).qty - 1 > 0) {
          document.getElementById(inputID).value = parseInt(selectedNS.find(p => p.item_code === product.item_code).qty) - 1;
          setSelectedNS(selectedNS.map(p => p.item_code === product.item_code ? { ...p, qty: (p.qty || 0) - 1 } : p));
        } else {
          handleRemoveProduct(product.item_code, "NS", inputID);
        }
      }
    } else if (tranCode === 'ZRP') {
      if (selectedRP.find(p => p.item_code === product.item_code)) {
        // 產品已在RP列表中，更新數量
        if (selectedRP.find(p => p.item_code === product.item_code).qty - 1 > 0) {
          document.getElementById(inputID).value = parseInt(selectedRP.find(p => p.item_code === product.item_code).qty) - 1;
          setSelectedRP(selectedRP.map(p => p.item_code === product.item_code ? { ...p, qty: (p.qty || 0) - 1 } : p));
        } else {
          handleRemoveProduct(product.item_code, "RP", inputID);
        }
      }
    } else if (tranCode === 'ZSA') {
      if (selectedSA.find(p => p.item_code === product.item_code)) {
        // 產品已在SA列表中，更新數量
        if (selectedSA.find(p => p.item_code === product.item_code).qty - 1 > 0) {
          document.getElementById(inputID).value = parseInt(selectedSA.find(p => p.item_code === product.item_code).qty) - 1;
          setSelectedSA(selectedSA.map(p => p.item_code === product.item_code ? { ...p, qty: (p.qty || 0) - 1 } : p));
        } else {
          handleRemoveProduct(product.item_code, "SA", inputID);
        }
      }
    }
  };

  // 更新產品數量
  const handleQuantityChange = (item, qty, tranCode) => {
    const inputID = item.item_code + "_" + tranCode;
    sharedconfigs.forEach(configs => {
      if (configs.zkey === 'ZNS_MAX') {
        ns_max.current = parseInt(configs.zvalue);
      }
      if (configs.zkey === 'ZRP_MAX') {
        rp_max.current = parseInt(configs.zvalue);
      }
      if (configs.zkey === 'ZSA_MAX') {
        sa_max.current = parseInt(configs.zvalue);
      }
    });
    if (qty < 0) {
      document.getElementById(inputID).value = '';
    } else {
      if (tranCode === 'ZNS') {
        if (parseInt(qty) > parseInt(ns_max.current)) {
          document.getElementById(inputID).value = '';
        } else {
          if (selectedNS.find(p => p.item_code === item.item_code)) {
            // 產品已在列表中
            if (parseInt(qty) === 0 || qty === '') {
              // 删除列表中產品
              handleRemoveProduct(item.item_code, "NS", inputID);
            } else {
              // 更新NS數量
              setSelectedNS(selectedNS.map(p => p.item_code === item.item_code ? { ...p, qty: parseInt(qty) || 0 } : p));
            }
          } else {
            if (qty > 0) {
              // 添加NS新產品
              setSelectedNS([...selectedNS, { ...item, qty: parseInt(qty) }]);
            } else {
              document.getElementById(inputID).value = '';
            }
          }
        }
      } else if (tranCode === 'ZRP') {
        if (parseInt(qty) > parseInt(rp_max.current)) {
          document.getElementById(inputID).value = '';
        } else {
          if (selectedRP.find(p => p.item_code === item.item_code)) {
            // 產品已在列表中
            if (parseInt(qty) === 0 || qty === '') {
              // 删除列表中產品
              handleRemoveProduct(item.item_code, "RP", inputID);
            } else {
              // 更新RP數量
              setSelectedRP(selectedRP.map(p => p.item_code === item.item_code ? { ...p, qty: parseInt(qty) || 0 } : p));
            }
          } else {
            if (qty > 0) {
              // 添加RP新產品
              setSelectedRP([...selectedRP, { ...item, qty: parseInt(qty) }]);
            } else {
              document.getElementById(inputID).value = '';
            }
          }
        }
      } else if (tranCode === 'ZSA') {
        if (parseInt(qty) > parseInt(sa_max.current)) {
          document.getElementById(inputID).value = '';
        } else {
          if (selectedSA.find(p => p.item_code === item.item_code)) {
            if (parseInt(qty) === 0 || qty === '') {
              // 删除列表中產品
              handleRemoveProduct(item.item_code, "SA", inputID);
            } else {
              // 更新SA數量
              setSelectedSA(selectedSA.map(p => p.item_code === item.item_code ? { ...p, qty: parseInt(qty) || 0 } : p));
            }
          } else {
            if (qty > 0) {
              // 添加SA新產品
              setSelectedSA([...selectedSA, { ...item, qty: parseInt(qty) }]);
            } else {
              document.getElementById(inputID).value = '';
            }
          }
        }
      }
    }
  };

  // 從訂單中移除產品
  const handleRemoveProduct = (itemCode, tranCode, inputElementID) => {
    switch (tranCode) {
      case "NS":
        setSelectedNS(selectedNS.filter(p => p.item_code !== itemCode));
        break;
      case "RP":
        setSelectedRP(selectedRP.filter(p => p.item_code !== itemCode));
        break;
      case "SA":
        setSelectedSA(selectedSA.filter(p => p.item_code !== itemCode));
        break;
      default:
        setSelectedNS(selectedNS.filter(p => p.item_code !== itemCode));
    }
    document.getElementById(inputElementID).value = '';
  };

  const handleImageClick = () => {
    setIsEnlarged(!isEnlarged);
  };

  const openConfirm = async (e) => {
    await loadConfigs();
    let hktTime = new Date().toLocaleString('en-HK', { timeZone: 'Asia/Hong_Kong', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });


    sharedconfigs.forEach(configs => {
      if (configs.zkey === cutoff_str.current) {
        cutoff.current = configs.zvalue;
        hktTime = new Date(configs.dt).toLocaleString('en-HK', { timeZone: 'Asia/Hong_Kong', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
      }
    });
    cutoff.current.replaceAll(':', '');
    hktTime.replaceAll(':', '');


    if (cutoff.current < hktTime && formData.deliveryDate === tomorrowDate) {
      setError(t('msg_tmrCut'))
      window.scrollTo(0, 0);
      return;
    }

    await checkOrderExist(formData.customerCode, formData.deliveryDate);
    if (orderExists === true) {
      setError(t('msg_orderExist'));
      window.scrollTo(0, 0);
      return;
    }
    totalOrderQuantity = 0;
    // if(skip){
    //   setSelectedAll([{ item_code: 'SKIP', item_desc: t('skipOrder'), image_url: '/images/products/SKIP.png', orderQty: 1, replaceQty: 0, sampleQty: 0 }]);
    //   totalOrderQuantity = 1;
    // }else{
    selectedNS.forEach(n => {
      orderItems[n.item_code].orderQty = n.qty;
      orderItems[n.item_code].image_url = n.image_url;
      orderItems[n.item_code].item_desc = n.item_desc;
      // setSelectedAll(prev => ({ ...prev, [n.item_code]: { ...prev[n.item_code], ['orderQty']: n.qty } }));
      totalOrderQuantity = parseInt(totalOrderQuantity) + parseInt(n.qty);
    });
    selectedRP.forEach(r => {
      orderItems[r.item_code].replaceQty = r.qty;
      orderItems[r.item_code].image_url = r.image_url;
      orderItems[r.item_code].item_desc = r.item_desc;
      // setSelectedAll(prev => ({ ...prev, [r.item_code]: { ...prev[r.item_code], ['replaceQty']: r.qty } }));
      totalOrderQuantity = parseInt(totalOrderQuantity) + parseInt(r.qty);
    });
    selectedSA.forEach(s => {
      orderItems[s.item_code].sampleQty = s.qty;
      orderItems[s.item_code].image_url = s.image_url;
      orderItems[s.item_code].item_desc = s.item_desc;
      // setSelectedAll(prev => ({ ...prev, [s.item_code]: { ...prev[s.item_code], ['sampleQty']: s.qty } }));
      totalOrderQuantity = parseInt(totalOrderQuantity) + parseInt(s.qty);
    });

    const newArray = [];
    Object.entries(orderItems).forEach(([key, value]) => {
      if (value.orderQty > 0 || value.replaceQty > 0 || value.sampleQty > 0) {
        newArray.push({ item_code: key, item_desc: value.item_desc, image_url: value.image_url, orderQty: value.orderQty, replaceQty: value.replaceQty, sampleQty: value.sampleQty });
      }
    });
    setSelectedAll(newArray);
    // }

    document.getElementById("btn_submit").hidden = true;
    document.getElementById("totalQty").innerHTML = ' ' + totalOrderQuantity;
    document.getElementById("myForm").style.display = "block";

  }

  const closeConfirm = async (e) => {
    products.forEach(product => {
      initialOrderItems[product.item_code] = {
        image_url: '',
        item_desc: '',
        orderQty: 0,
        replaceQty: 0,
        sampleQty: 0
      };
    });
    setOrderItems(initialOrderItems);
    document.getElementById("totalQty").innerHTML = '';
    document.getElementById("myForm").style.display = "none";
    document.getElementById("btn_submit").hidden = false;
  }

  const handleAgree = (value) => {
    setAgree(value);
    if (value === 1) {
      document.getElementById("finalSubmit").disabled = false;
    } else {
      document.getElementById("finalSubmit").disabled = true;
    }
  }

  const handleVanSale = (value) => {
    setNeedVanSale(value);
  }

  // const handleSkip = (value) => {
  //   setSkip(value);
  //   if (value === 1){
  //     setSelectedNS([{ item_code: 'SKIP', qty: 1 }]);
  //     document.getElementById("btn_submit").disabled = false;
  //   }else{
  //     document.getElementById("btn_submit").disabled = true;
  //     loadProducts(formData.customerCode, formData.div);
  //     setSelectedNS([]);
  //     setSelectedRP([]);
  //     setSelectedSA([]);
  //     setSelectedAll([]);
  //     setOldFavorite([]);
  //     setNewFavorite([]);
  //   }
  // }

  // 提交訂單
  const handleSubmit = async () => {
    // e.preventDefault();
    setLoading(true);

    // 表單驗證
    if (!formData.customerCode) {
      closeConfirm();
      setError(t('msg_noCustomer'));
      window.scrollTo(0, 0);
      return;
    }

    if (!formData.deliveryDate) {
      formData.deliveryDate = document.getElementById("deliveryDate").options[0].value;
      if (!formData.deliveryDate) {
        closeConfirm();
        setError(t('msg_noDate'));
        window.scrollTo(0, 0);
        return;
      }
    }

    const today = new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Hong_Kong' }).replaceAll('-', '');
    const target = formData.deliveryDate.replaceAll('-', '');
    if (target <= today) {
      closeConfirm();
      setError(t('msg_wrongDate'));
      window.scrollTo(0, 0);
      return;
    }

    let hktTimeNow = new Date().toLocaleString('en-HK', { timeZone: 'Asia/Hong_Kong', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });

    if (cutoff.current < hktTimeNow && formData.deliveryDate === tomorrowDate) {
      closeConfirm();
      setError(t('msg_tmrCut'))
      window.scrollTo(0, 0);
      return;
    }

    if (selectedNS.length === 0 && selectedRP.length === 0 && selectedSA.length === 0) {
      closeConfirm();
      setError(t('msg_noItem'));
      window.scrollTo(0, 0);
      return;
    }

    await checkOrderExist(formData.customerCode, formData.deliveryDate);
    if (orderExists === true) {
      closeConfirm();
      setError(t('msg_orderExist'));
      window.scrollTo(0, 0);
      return;
    }

    // 驗證每個產品的數量
    const invalidProductNS = selectedNS.find(p => !p.qty || p.qty <= 0);
    const invalidProductRP = selectedNS.find(r => !r.qty || r.qty <= 0);
    const invalidProductSA = selectedNS.find(s => !s.qty || s.qty <= 0);
    if (invalidProductNS) {
      setError(t('msg_product') + `${invalidProductNS.item_desc}` + t('msg_invalidNS'));
      window.scrollTo(0, 0);
      return;
    }
    if (invalidProductRP) {
      setError(t('msg_product') + `${invalidProductRP.item_desc}` + t('msg_invalidRP'));
      window.scrollTo(0, 0);
      return;
    }
    if (invalidProductSA) {
      setError(t('msg_product') + `${invalidProductSA.item_desc} ` + t('msg_invalidSA'));
      window.scrollTo(0, 0);
      return;
    }

    setError('');
    setSuccess('');

    // 準備我的最愛項目數據
    try {
      const favoritesEqual = (before, after) =>
        after.length === before.length &&
        !before.some(({ customer, item, seq }, i) =>
          (({ customer: otherCustomer, item: otherItem, seq: otherSeq }) =>
            customer !== otherCustomer || item !== otherItem || seq !== otherSeq)
            (after[i]));
      if (favoritesEqual(oldFavorite, newFavorite) === true) {
        //沒有改變, 不用更新我的最愛項目數據
      } else {
        const onlyInOldDelete = oldFavorite.filter(of => !newFavorite.some(f2 => f2.customer === of.customer && f2.item === of.item && f2.seq === of.seq));
        const onlyInNewInsert = newFavorite.filter(nf => !oldFavorite.some(f1 => f1.customer === nf.customer && f1.item === nf.item && f1.seq === nf.seq));
        // 提交
        await api.post('/customers/favorite', {
          needDelete: onlyInOldDelete,
          needInsert: onlyInNewInsert
        });
      }
    } catch (err) {
      // Ignore the error, continue create order
      console.error('更新我的最愛項目失敗: ', err);
    }

    try {
      // 準備訂單項目數據
      const items = selectedNS.map(p => ({
        item_code: p.item_code,
        qty: p.qty,
        tran_code: 'ZNS' // 新銷售
      }));

      if (selectedRP.length > 0) {
        selectedRP.forEach(r => {
          items.push({
            item_code: r.item_code,
            qty: r.qty,
            tran_code: 'ZRP'
          });
        });
      }

      if (selectedSA.length > 0) {
        selectedSA.forEach(s => {
          items.push({
            item_code: s.item_code,
            qty: s.qty,
            tran_code: 'ZSA'
          });
        });
      }

      items.sort((a, b) => a.item_code.localeCompare(b.item_code));

      // 提交訂單
      const response = await api.post('/orders', {
        cust_code: formData.customerCode,
        delivery_date: formData.deliveryDate,
        div: formData.div,
        // skipOrder: skip ? 2 : 0,
        needICVanSale: needVanSale ? 1 : 0,
        items
      });

      setSuccess(t('msg_orderCreateSuccess'));

      // 延遲後導航到訂單詳情頁面
      setTimeout(() => {
        navigate(`/orders/${response.data.data.order_id}`);
      }, 1500);
    } catch (err) {
      closeConfirm();
      setError(t('msg_orderCreateFail') + ': ' + (err.response?.data?.message || t('msg_tryLater')));
      window.scrollTo(0, 0);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    }
  };

  // 獲取產品圖片或使用預設圖片
  const getProductImage = (product) => {
    if (product.image_url) {
      return product.image_url;
    } else {
      return '/images/products/' + product.item_code + '.png';
    }
  };

  const errorClose = async () => {
    document.getElementById("myError").style.display = "none";
    window.scrollTo(0, 0);
  };

  return (
    <Container className="order-new-container">
      <Row className="align-items-center mb-2">
        <Col xs={6}>
          <h2>{t('placeOrder')}</h2>
        </Col>
        <Col xs={6} className="text-end">
          <Button variant="outline-success" onClick={() => navigate('/orders')}>
            {t('orderList')}
          </Button>
        </Col>
      </Row>

      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}

      <div id="myError" className="error">
        <div className="error-content">
          <h6>&nbsp;</h6>
          <p style={{ textAlign: 'center' }}>{t('msg_orderExist')}</p>
          <span style={{ marginLeft: '15%' }}>
            <Button
              variant="success"
              className="m-2"
              style={{ width: '80px', height: '35px', padding: '2px', margin: '3px' }}
              onClick={() => errorClose()}
            >
              {t('yes')}
            </Button>
            <Button
              variant="primary"
              className="m-2"
              style={{ width: '80px', height: '35px', padding: '2px', margin: '3px' }}
              onClick={() => navigate('/orders')}
            >
              {t('orderList')}
            </Button>
          </span>
        </div>
      </div>

      <Form>
        <Card className="mb-2">
          {/* <Card.Header>{t('orderInformation')}</Card.Header> */}
          <Card.Header>
            <div className="d-flex justify-content-between align-items-center">
              <span>{t('orderInformation')}</span>
              <InputGroup className="product-search" style={{ width: '60%' }}>
                <Form.Control
                  placeholder={t('searchCustomer')}
                  value={searchCustomer}
                  onChange={handleCustomerSearchChange}
                  disabled={user.role !== 0 || loading || productLoading || favoritesLoading}
                />
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </Card.Header>
          <Card.Body className="p-2">
            <Row>
              <Col xs={12} md={6}>
                <Form.Group>
                  <span className="form-row">
                    <Form.Label style={{ fontSize: '100%', marginTop: '8px' }}>{t('customer')}</Form.Label>
                    <Form.Select
                      name="customerCode"
                      value={formData.customerCode}
                      onChange={handleChange}
                    // disabled={loading || (user.role !== 0 && selectedCustomer)}
                    >
                      {user.role !== 0 ? '' : <option value="">{t('selectCustomer')}</option>}
                      {filteredCustomers.map(customer => (
                        <option key={customer.cust_code} value={customer.cust_code}>
                          {customer.cust_name} ({customer.cust_code})
                        </option>
                      ))}
                    </Form.Select>
                  </span>
                </Form.Group>
              </Col>

              {/* <Col md={3}>
                <Form.Group>
                  <span className="form-row">
                    <Form.Label>類別</Form.Label>
                    <Form.Select
                      name="div"
                      value={formData.div}
                      onChange={handleChange}
                      disabled={loading}
                    >
                      <option value="10">牛奶</option>
                      <option value="20">雪糕</option>
                    </Form.Select>
                  </span>
                </Form.Group>
              </Col> */}

              <Col xs={12} md={6}>
                <Form.Group>
                  <span className="form-row">
                    <Form.Label style={{ fontSize: '100%', marginTop: '8px' }}>{t('deliveryDate')}</Form.Label>
                    {/* <Form.Control */}
                    <Form.Select
                      // type="date"
                      id="deliveryDate"
                      name="deliveryDate"
                      value={formData.deliveryDate}
                      // min={new Date().toJSON().slice(0,10)}
                      // step={2}
                      onChange={handleChange}
                      disabled={loading}
                    />
                  </span>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <p style={{ color: 'red', backgroundColor: 'yellow', marginBottom: '6px' }}>{t('reminder', { time: cutoff.current.substring(0, 5) })}</p>

        {/* <Form.Group className="mb-3" style={{display: 'flex'}} hidden>
          <Form.Check
            className='m-0'
            type="checkbox" 
            id="skip"
            disabled 
            onChange={(e) => handleSkip(e.target.checked ? 1 : 0)}
          /> 
          <Form.Label>{t('skipOrder')}</Form.Label>
        </Form.Group> */}

        <Row className="mb-1">
          <Col md={12}>
            <Card className="h-100 mb-1">
              <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                  <span>{t('productList')}</span>
                  <InputGroup className="product-search" style={{ width: '60%' }}>
                    <Form.Control
                      placeholder={t('searchProduct')}
                      value={searchProducts}
                      onChange={handleProductSearchChange}
                      disabled={!formData.customerCode || productLoading || favoritesLoading}
                    />
                    <InputGroup.Text>
                      <FaSearch />
                    </InputGroup.Text>
                  </InputGroup>
                </div>
              </Card.Header>
              <Card.Body className="p-0">
                {productLoading ? (
                  <div className="text-center my-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">載入中...</span>
                    </div>
                  </div>
                ) : !formData.customerCode ? (
                  <div className="text-center my-5">
                    <p>{t('noselectedCustomer')}</p>
                  </div>
                ) : filteredProducts.length === 0 ? (
                  <div className="text-center my-5">
                    <p>{searchProducts ? '沒有找到匹配的產品' : '沒有找到產品'}</p>
                  </div>
                ) : (
                  <div className="product-grid">
                    {filteredProducts.map((product) => (
                      <div key={product.item_code} className="product-card">
                        <span>
                          {product.seq === 1 ?
                            (<input
                              className="star"
                              defaultChecked
                              type="checkbox"
                              id={'CB_' + product.item_code}
                              value={product.item_code}
                              onClick={(e) => handleFavorites(product.item_code, e.target.checked, 1)}
                            ></input>
                            ) :
                            (<input
                              className="star"
                              type="checkbox"
                              id={'CB_' + product.item_code}
                              value={product.item_code}
                              onClick={(e) => handleFavorites(product.item_code, e.target.checked, 1)}
                            ></input>
                            )
                          }
                          <span className="product-title">
                            <span className={product.seq >= 2 ? "newproduct" : "visually-hidden"}>New&nbsp;</span>
                            {user.role === 0 ? <span>{product.item_code}</span> : ''}
                            <span>&nbsp;{product.item_desc}</span>
                          </span>
                        </span>
                        <div className={user.role === 0 ? 'product-image2' : 'product-image'}>
                          <img
                            className={`image ${isEnlarged ? 'enlarged' : ''}`}
                            id={product.item_code}
                            onClick={handleImageClick}
                            src={getProductImage(product)}
                            alt={product.item_desc}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = formData.div === '10' ? '/images/products/default.svg' : '/images/default-ice-cream.png';
                            }}
                          />
                          <div className="product-info">
                            <table>
                              <tbody>
                                <tr>
                                  <td className="type-title">{t('sales')}</td>
                                  <td>
                                    <Button
                                      variant="light"
                                      size="sm"
                                      style={{ width: '29px', height: '29px', borderStyle: 'solid', borderColor: 'silver' }}
                                      className="w-10" /* 讓按鈕寬度100% */
                                      onClick={() => handleSubtractProduct(product, 'ZNS')}
                                      disabled={loading}
                                    >
                                      -
                                    </Button>
                                  </td>
                                  <td>
                                    <Form.Control
                                      id={product.item_code + "_ZNS"}
                                      type="number"
                                      min="1"
                                      max={ns_max.current}
                                      style={{ minWidth: '40px' }}
                                      onChange={(e) => handleQuantityChange(product, e.target.value, 'ZNS')}
                                      size="sm"
                                      disabled={loading}
                                    />
                                  </td>
                                  <td>
                                    <Button
                                      variant="light"
                                      size="sm"
                                      style={{ width: '29px', height: '29px', borderStyle: 'solid', borderColor: 'silver' }}
                                      className="w-10" /* 讓按鈕寬度100% */
                                      onClick={() => handleAddProduct(product, 'ZNS')}
                                      disabled={loading}
                                    >
                                      +
                                    </Button>
                                  </td>
                                </tr>
                                {product.no_rp === 'X' ? <tr></tr> :
                                  <tr>
                                    <td className="type-title">{t('replace')}</td>
                                    <td>
                                      <Button
                                        variant="light"
                                        size="sm"
                                        style={{ width: '29px', height: '29px', borderStyle: 'solid', borderColor: 'silver' }}
                                        className="w-10" /* 讓按鈕寬度100% */
                                        onClick={() => handleSubtractProduct(product, 'ZRP')}
                                        disabled={loading}
                                      >
                                        -
                                      </Button>
                                    </td>
                                    <td>
                                      <Form.Control
                                        id={product.item_code + "_ZRP"}
                                        type="number"
                                        min="1"
                                        max={rp_max.current}
                                        style={{ minWidth: '40px' }}
                                        onChange={(e) => handleQuantityChange(product, e.target.value, 'ZRP')}
                                        size="sm"
                                        disabled={loading}
                                      />
                                    </td>
                                    <td>
                                      <Button
                                        variant="light"
                                        size="sm"
                                        style={{ width: '29px', height: '29px', borderStyle: 'solid', borderColor: 'silver' }}
                                        className="w-10" /* 讓按鈕寬度100% */
                                        onClick={() => handleAddProduct(product, 'ZRP')}
                                        disabled={loading}
                                      >
                                        +
                                      </Button>
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>

                      </div>
                    ))}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <div className="text-end">
          <Button
            style={wwidth <= 768 ? { position: 'fixed', zIndex: '1000', right: '4%', top: '88%' } : {}}
            // variant="primary"
            id='btn_submit'
            onClick={() => openConfirm()}
            disabled={loading || (selectedNS.length === 0 && selectedRP.length === 0 && selectedSA.length === 0)}
          >
            {loading ? t('submitting') : t('submitOrder')}
          </Button>
          {/* <Button
            variant="secondary"
            className="me-2"
            onClick={() => navigate('/orders')}
            disabled={loading}
          >
            {t('cancel')}
          </Button> */}
        </div>
        <div id="myForm" className={wwidth <= 768 ? 'modalL' : 'modalS'}>
          <div className={wwidth <= 768 ? 'modalL-content' : 'modalS-content'}>
            <span>
              {t('orderItem')}
              <span style={{ fontWeight: 'bold', float: 'right' }}>{t('totalQty')}:
                <span id='totalQty' ></span>{t('pieces')}
              </span>
            </span>


            {/* <Form onSubmit={handleSubmit}> */}
            <Card>
              <Table hover size="sm" className="order-products-table">
                <thead>
                  <tr>
                    <th>{t('image')}</th>
                    <th>{t('description')}</th>
                    <td style={{ textAlign: 'center', fontSize: '110%' }}><Badge bg="success">{t('sales')}</Badge></td>
                    <td style={{ textAlign: 'center', fontSize: '110%' }}><Badge bg="warning">{t('replace')}</Badge></td>
                    {/* {user.role !== 0 ? <></> : <td style={{ textAlign: 'center', fontSize: '110%' }}><Badge bg="secondary">{t('sample')}</Badge></td>} */}
                    {/* <th style={{ minWidth: '40px', textAlign: 'center' }}>{t('qty')}</th> */}
                  </tr>
                </thead>
                <tbody>
                  {selectedAll.map((product) => (
                    <tr key={product.item_code}>
                      <td>
                        <img
                          src={getProductImage(product)}
                          alt={product.item_desc}
                          className="confirm-thumbnail"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = product.div === '10' ? '/images/default.svg' : '/images/default-ice-cream.png';
                          }}
                        />
                      </td>
                      <td style={{ fontSize: 'clamp(1rem, 2.5vw, 1.25rem)' }}>{product.item_desc}</td>
                      <td style={{ textAlign: 'center', fontSize: 'clamp(1rem, 2.5vw, 1.25rem)' }}>{product.orderQty || ''}</td>
                      <td style={{ textAlign: 'center', fontSize: 'clamp(1rem, 2.5vw, 1.25rem)' }}>{product.replaceQty || ''}</td>
                      {/* {user.role !== 0 ? <></> : <td style={{ textAlign: 'center', fontSize: 'clamp(1rem, 2.5vw, 1.25rem)' }}>{product.sampleQty || ''}</td>} */}
                    </tr>
                  ))}
                  {/* {selectedNS.map((product) => (
                    <tr key={product.item_code}>
                      <td>
                        <img
                          src={getProductImage(product)}
                          alt={product.item_desc}
                          className="confirm-thumbnail"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = product.div === '10' ? '/images/default.svg' : '/images/default-ice-cream.png';
                          }}
                        />
                      </td>
                      <td>{product.item_desc}</td>
                      <td><Badge bg="success">{t('sales')}</Badge></td>
                      <td style={{ textAlign: 'center' }}>{product.qty || ''}</td>
                    </tr>
                  ))}
                  {selectedRP.map((product) => (
                    <tr key={product.item_code}>
                      <td>
                        <img
                          src={getProductImage(product)}
                          alt={product.item_desc}
                          className="confirm-thumbnail"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = product.div === '10' ? '/images/default.svg' : '/images/default-ice-cream.png';
                          }}
                        />
                      </td>
                      <td>{product.item_desc}</td>
                      <td><Badge bg="warning">{t('replace')}</Badge></td>
                      <td style={{ textAlign: 'center' }}>{product.qty || ''}</td>
                    </tr>
                  ))} */}
                  {/* {selectedSA.map((product) => (
                    <tr key={product.item_code}>
                      <td>
                        <img
                          src={getProductImage(product)}
                          alt={product.item_desc}
                          className="confirm-thumbnail"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = product.div === '10' ? '/images/default.svg' : '/images/default-ice-cream.png';
                          }}
                        />
                      </td>
                      <td>{product.item_desc}</td>
                      <td><Badge bg="secondary">{t('sample')}</Badge></td>
                      <td style={{ textAlign: 'center' }}>{product.qty || ''}</td>
                    </tr>
                  ))} */}
                </tbody>
              </Table>
            </Card>
            {/* </Form> */}
            <Form.Group className="mb-3" style={{ display: 'flex' }}>
              <Form.Check
                className='m-0'
                type="checkbox"
                id="agree"
                required
                onChange={(e) => handleAgree(e.target.checked ? 1 : 0)}
              />
              <Form.Label>{t('agree_tc')} <a href="/terms-and-conditions" target="_blank">{t('terms_and_conditions')}</a></Form.Label>
            </Form.Group>

            <Form.Group className="mb-3" style={{ display: 'flex' }}>
              <Form.Check
                type="checkbox"
                onChange={(e) => handleVanSale(e.target.checked ? 1 : 0)}
              />
              <Form.Label>{t('need_ic')}</Form.Label>
            </Form.Group>

            <span>
              <Button
                variant="secondary"
                className="me-2"
                style={{ width: '70px', height: '40px' }}
                onClick={() => closeConfirm()}
              >
                {t('back')}
              </Button>
              <Button
                id='finalSubmit'
                variant="primary"
                className="me-2"
                style={{ width: '110px', height: '40px', float: 'right' }}
                // type="submit"
                onClick={() => handleSubmit()}
                disabled={agree === 0 || loading || (selectedNS.length === 0 && selectedRP.length === 0 && selectedSA.length === 0)}
              >
                {loading ? t('submitting') : agree ? t('confirmSubmit') : t('noTickConfirm')}
              </Button>
            </span>
          </div>

        </div>
      </Form>
    </Container>
  );
};

export default OrderNew;